const schatten = {

    /**
     * Initialize.
     *
     */
    init() {
        this.infinityScroll();
    },
    /**
     * Infinity scroll schatten
     *
     */
    infinityScroll() {
        var canBeLoaded = true;
        $(window).scroll(function () {
            if (designated_loadmore_params.current_page >= designated_loadmore_params.max_page) {
                return;
            }
            var data = {
                'action': 'loadmore',
                'query': designated_loadmore_params.posts,
                'page': designated_loadmore_params.current_page
            };

            function isScrolledIntoView(elem) {
                var docViewTop = $(window).scrollTop();
                var docViewBottom = docViewTop + $(window).height();

                var elemTop = $(elem).offset().top;
                var elemBottom = elemTop + $(elem).height();

                return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
            }

            function Utils() {
            }

            Utils.prototype = {
                constructor: Utils,
                isElementInView: function (element, fullyInView) {
                    var pageTop = $(window).scrollTop();
                    var pageBottom = pageTop + $(window).height();
                    var elementTop = $(element).offset().top;
                    var elementBottom = elementTop + $(element).height();

                    if (fullyInView === true) {
                        return ((pageTop < elementTop) && (pageBottom > elementBottom));
                    } else {
                        return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
                    }
                }
            };
            var Utils = new Utils();
            var isElementInView = Utils.isElementInView($('a.schat:last-of-type'), true);
            if (isElementInView && canBeLoaded == true) {
                $.ajax({
                    url: designated_loadmore_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function (xhr) {
                        canBeLoaded = false;
                        $('.loading').show();
                    },
                    success: function (data) {
                        if (data) {
                            $('.loading').hide();
                            $('#all_schatten').find('a.schat:last-of-type').after(data);
                            canBeLoaded = true;
                            designated_loadmore_params.current_page++;
                        }
                    }
                });
            }
        });
    }
};

module.exports = schatten;